/**
 * DotNavigation Component
 */

import './styles.scss';

import { times } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Heading from '../../../atoms/text/Heading';

interface IOwnProps {
  className?: string;
  currentDot: number;
  interactive?: boolean;
  totalDots: number;
  showProgress?: boolean;
}

interface IOwnState {
  currentDot: number | null;
}

const classes = new BEM('dot-navigation');

export default class DotNavigation extends React.Component<IOwnProps, IOwnState> {

  constructor(props) {
    super(props);

    this.state = {
      currentDot: null,
    };
  }

  onMouseEnterDot(dot: number) {
    this.setState({ currentDot: dot });
  }

  onMouseLeaveDot() {
    this.setState({ currentDot: null });
  }

  render() {
    const {
      className,
      interactive,
      totalDots,
    } = this.props;

    const classModifiers = {
      interactive: !!interactive,
    };

    const currentDot = this.state.currentDot || this.props.currentDot;

    return (
      <div {...classes('', classModifiers, className) }>
        <Heading is="h6" {...classes('progress') }>{`${this.props.currentDot} / ${totalDots}`}</Heading>
        <div {...classes('dots') }>
          {times(totalDots, (n) =>
            <div
              key={`dot-${n}`}
              onMouseEnter={() => interactive && this.onMouseEnterDot(n + 1)}
              onMouseLeave={() => interactive && this.onMouseLeaveDot()}
              {...classes('dot') }
            />,
          )}
          <div {...classes('dot', 'current', `position--${currentDot}`) } />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Registration/DotNavigation.tsx